export enum FlameDetectorSensitivity {
  HIGH = "high",
  STANDARD = "standard",
  LOW = "low",
}

/**
 * Returns localized labels for flame detector sensitivity levels.
 * Must be a function (not a constant) to ensure $localize is called at runtime,
 * after loadTranslations() has been invoked during app initialization.
 */
export function getFlameDetectorSensitivityLabel(sensitivity: FlameDetectorSensitivity): string {
  const labels: Record<FlameDetectorSensitivity, string> = {
    [FlameDetectorSensitivity.HIGH]: $localize`:@@flameDetector.sensitivity.high:Hoch`,
    [FlameDetectorSensitivity.STANDARD]: $localize`:@@flameDetector.sensitivity.standard:Standard`,
    [FlameDetectorSensitivity.LOW]: $localize`:@@flameDetector.sensitivity.low:Niedrig`,
  };
  return labels[sensitivity];
}

export const FLAME_DETECTOR_SENSITIVITIES: FlameDetectorSensitivity[] = [
  FlameDetectorSensitivity.HIGH,
  FlameDetectorSensitivity.STANDARD,
  FlameDetectorSensitivity.LOW,
];

/**
 * Product property keys that map sensitivity levels to their
 * measured detection distance (in meters) in the product data.
 */
export const FLAME_DETECTOR_SENSITIVITY_PROPERTY_KEYS: Record<FlameDetectorSensitivity, string> = {
  [FlameDetectorSensitivity.HIGH]: "detectionDistance_high",
  [FlameDetectorSensitivity.STANDARD]: "detectionDistance_standard",
  [FlameDetectorSensitivity.LOW]: "detectionDistance_low",
};
